export default __webpack_public_path__ + "static/media/1962.ca425b26.png";